import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {AuthenticationNs, type SignUpNs} from '@shared/types';
import {useRegisterStore} from "@domains/auth/stores/register.store";
import {toast} from '@shared/ms-components'


export const activateAccountResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
    const isAuthPage = window.location.href.indexOf('/auth/') > -1;
    const payload = {
        activationCode: to.query.ac,
        userName: to.query.un,
    } as SignUpNs.ActivateAccountRequest;

    const registerStore = useRegisterStore();
    registerStore.checkActivationCode(payload).then((response) => {


        if (response.accountIsValid) {
            next({name: 'LetsStart', query: to.query});
        } else if (response.activationEmailResent) {
            toast.warning('Activation code expired. New activation email sent. Check mailbox');

            next({name: 'CheckEmail'});
        } else {
            next({name: AuthenticationNs.AuthenticationRouteEnums.SignUp});
        }
    }).catch(() => {
        next({name: AuthenticationNs.AuthenticationRouteEnums.SignUp});
    })

};
